export default __webpack_public_path__ + "static/media/team-01.5df24112.png";